module.exports = "img/photo12.7be8fe.jpeg";